import { MovementType } from "@/data/movementType";

/**
 * Type for the category option structure
 */
export type CategoryOption = {
  section_name: string;
  fields: string[];
};

/**
 * Default category options used across the application
 */
export const DEFAULT_CATEGORY_OPTIONS: CategoryOption[] = [
  {
    section_name: "account_fees",
    fields: [MovementType.FEES],
  },
  {
    section_name: "loan_flows",
    fields: [
      MovementType.HOME_LOAN,
      MovementType.OTHER_LOAN,
      MovementType.INTEREST,
    ],
  },
  {
    section_name: "revenue",
    fields: [MovementType.DIVIDEND, MovementType.ACCRUED_PAYMENT],
  },
  {
    section_name: "unlisted_asset_funds",
    fields: [
      MovementType.CAPITAL_CALL,
      MovementType.RETURN_EXCESS_CALL,
      MovementType.CALL_SUBSEQUENT_CLOSING,
      MovementType.CAPITAL_GAIN,
      MovementType.DISTRIBUTION,
      MovementType.RETURN_EXCESS_DISTRIBUTION,
      MovementType.RETURN_EXCESS_TEMPORARY_DISTRIBUTION,
      MovementType.DISTRIBUTION_SUBSEQUENT_CLOSING,
      MovementType.TEMPORARY_RETURN_CAPITAL,
      MovementType.TRANSFER_FUND_REALLOCATION,
    ],
  },
];

export type movementMap = {
  security: Record<string, string[] | Record<string, string[]>>;
  cash: Record<string, string[]>;
  cash_special_case: Record<string, string[]>;
};

export const DEFAULT_MOVEMENT_BY_ASSET_CATEGORY: movementMap = {
  security: {
    private_equity: {
      pos: [
        MovementType.CAPITAL_CALL,
        MovementType.CALL_SUBSEQUENT_CLOSING,
        MovementType.RETURN_EXCESS_DISTRIBUTION,
        MovementType.TRANSFER_FUND_REALLOCATION,
        MovementType.RETURN_EXCESS_TEMPORARY_DISTRIBUTION,
      ],
      neg: [
        MovementType.CAPITAL_GAIN,
        MovementType.DISTRIBUTION,
        MovementType.TEMPORARY_RETURN_CAPITAL,
        MovementType.DISTRIBUTION_SUBSEQUENT_CLOSING,
        MovementType.RETURN_EXCESS_CALL,
        MovementType.TRANSFER_FUND_REALLOCATION,
      ],
    },
    real_estate: {
      pos: [
        MovementType.CAPITAL_CALL,
        MovementType.CALL_SUBSEQUENT_CLOSING,
        MovementType.RETURN_EXCESS_DISTRIBUTION,
        MovementType.TRANSFER_FUND_REALLOCATION,
        MovementType.RETURN_EXCESS_TEMPORARY_DISTRIBUTION,
      ],
      neg: [
        MovementType.CAPITAL_GAIN,
        MovementType.DISTRIBUTION,
        MovementType.TEMPORARY_RETURN_CAPITAL,
        MovementType.DISTRIBUTION_SUBSEQUENT_CLOSING,
        MovementType.RETURN_EXCESS_CALL,
        MovementType.TRANSFER_FUND_REALLOCATION,
      ],
    },
  },
  cash: {
    equity: [MovementType.DIVIDEND],
    fund: [MovementType.DIVIDEND],
    cash: [MovementType.DIVIDEND],
    private_debt: [MovementType.ACCRUED_PAYMENT],
    structured_product: [MovementType.ACCRUED_PAYMENT],
  },
  cash_special_case: {
    "*": [MovementType.FEES],
  },
};

export const AUTOMATIC_TAG_MAP: string[] = ["private_equity", "real_estate"];
